import { useEffect } from 'react';

export enum Browser {
  Chrome = 'Chrome',
  Firefox = 'Firefox',
  Safari = 'Safari',
  Edge = 'Edge',
  Opera = 'Opera',
  Unknown = 'Unknown',
}

const SUPPORTED_BROWSERS = [Browser.Chrome, Browser.Safari] as const;

export const useBrowserDetection = () => {
  const browser = (() => {
    const ua = navigator.userAgent;
    // iOS-specific Chrome (CriOS), Firefox (FxiOS), Edge (EdgiOS)
    if (/crios/i.test(ua)) return Browser.Chrome;
    if (/fxios/i.test(ua)) return Browser.Firefox;
    if (/edgios/i.test(ua)) return Browser.Edge;

    // Regular desktop browsers
    if (/chrome|crmo/i.test(ua) && !/edg/i.test(ua)) return Browser.Chrome;
    if (/firefox/i.test(ua)) return Browser.Firefox;
    if (/edg/i.test(ua)) return Browser.Edge;
    if (/opr\//i.test(ua)) return Browser.Opera;

    // Safari must be checked after excluding CriOS, FxiOS, EdgiOS
    if (/safari/i.test(ua) && !/chrome|crios|crmo/i.test(ua)) return Browser.Safari;

    return Browser.Unknown;
  })();

  useEffect(() => {
    if (!SUPPORTED_BROWSERS.includes(browser as (typeof SUPPORTED_BROWSERS)[number])) {
      // eslint-disable-next-line no-alert
      alert(
        `Your browser (${browser}) is not supported. Please use one of: ${SUPPORTED_BROWSERS.join(
          ', ',
        )}, for the best experience.`,
      );
    }
  }, [browser]);
};
